import $ from 'jquery';

$('.cb.expand-collapse-button').click(function () {
  const id = $(this).attr("id")
  const topSection = $(`#college-board-toggle-top-section-${id}`);
  const bottomSection = $(`#college-board-toggle-bottom-section-${id}`);
  if(topSection.hasClass('closed')) {
    topSection.removeClass('closed')
    topSection.addClass('open')
    bottomSection.removeClass('hidden')
  } else {
    topSection.removeClass('open')
    topSection.addClass('closed')
    bottomSection.addClass('hidden')
  }
});

$('.interactive-wrapper.qa-section').click(function () {
  const button = $(this);
  const answerSection = $('#' + button.attr('aria-controls'));
  const isExpanded = button.attr('aria-expanded') === 'true';

  const innerTextElement = button.find('.expand-collapse-button p').eq(0);
  const innerImgElement = button.find('.expand-collapse-button img').eq(0);
  const expandSrc = 'https://assets.quill.org/images/shared/expand.svg';
  const collapseSrc = 'https://assets.quill.org/images/shared/collapse.svg';

  if (isExpanded) {
    button.attr('aria-expanded', 'false');
    answerSection.removeClass('show').addClass('hide');
    if (innerTextElement.length) { innerTextElement.text('Expand'); }
    if (innerImgElement.length) { innerImgElement.attr('src', expandSrc); }
  } else {
    button.attr('aria-expanded', 'true');
    answerSection.removeClass('hide').addClass('show');
    if (innerTextElement.length) { innerTextElement.text('Collapse'); }
    if (innerImgElement.length) { innerImgElement.attr('src', collapseSrc); }
  }
});

